import React, { useState, useEffect } from 'react';
import { MdAdd } from "react-icons/md";
import { RiSubtractLine } from "react-icons/ri";

// New color scheme for each question type
const questionTypes = [
    { name: 'Easy', color: '#4a90e2', points: 1 },      // Light blue
    { name: 'Medium', color: '#f5a623', points: 2 },    // Orange
    { name: 'Hard', color: '#50e3c2', points: 4 }       // Aqua green
];

// Initialize data from local storage or set defaults
const initializeData = () => {
    const savedData = JSON.parse(localStorage.getItem('extraPointsData'));
    return savedData || {
        easy: 0,
        medium: 0,
        hard: 0,
        totalPoints: 0,
        todayEasy: 0,
        todayMedium: 0,
        todayHard: 0,
    };
};

const ExtraPoints = () => {
    const [data, setData] = useState(initializeData);

    // Save data to local storage whenever `data` changes
    useEffect(() => {
        localStorage.setItem('extraPointsData', JSON.stringify(data));
    }, [data]);

    const handleQuestionChange = (type, value) => {
        setData((prevData) => {
            const newCount = prevData[`today${type}`] + value;
            if (newCount < 0) return prevData; // Prevent negative values

            const pointsChange = questionTypes.find(q => q.name === type).points * value;

            return {
                ...prevData,
                [`today${type}`]: newCount,
                totalPoints: prevData.totalPoints + pointsChange,
            };
        });
    };

    return (
        <div style={{
            display: "flex", justifyContent: "center", alignItems: "center", margin: "3rem 0", flexDirection: "column",
        }}>
            <div style={{
                display: "flex", flexDirection: "column", alignItems: "center", width: "100%", minHeight: "100vh", marginTop: "8rem",
            }}>
                <div style={{
                    marginBottom: "2rem",
                    padding: "1rem 3rem",
                    fontSize: "30px",
                    fontWeight: "bold",
                    background: "#3a6cf0", // New blue for main points display
                    color: "white",
                    borderRadius: "10px",
                    display: "inline-block",
                    width: "60%",
                    textAlign: "center"
                }}>
                    Extra Points: {data.totalPoints}
                </div>
                <div style={{ display: "flex", justifyContent: "space-around", width: "100%" }}>
                    {questionTypes.map(type => (
                        <div key={type.name} style={{ display: "flex", alignItems: "center" }}>
                            <button style={{ background: type.color, color: "white", fontSize: "30px", height: "3rem", width: "3rem", borderRadius: "10%", border: "none", cursor: "pointer", paddingTop: "10px" }} onClick={() => handleQuestionChange(type.name, -1)}>
                                <RiSubtractLine />
                            </button>
                            <div style={{ margin: "0 1rem", padding: "1rem", width: "10rem", fontSize: "20px", fontWeight: "bold", background: type.color, color: "white", borderRadius: "10px", textAlign: "center" }}>
                                {type.name} Ques: {data[`today${type.name}`]}
                            </div>
                            <button style={{ background: type.color, color: "white", fontSize: "30px", height: "3rem", width: "3rem", borderRadius: "10%", border: "none", cursor: "pointer", paddingTop: "10px" }} onClick={() => handleQuestionChange(type.name, 1)}>
                                <MdAdd />
                            </button>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default ExtraPoints;
